import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { SnackbarProvider } from 'notistack';
import { NotistackSnackbar } from '@dev/ee-components';
import { makeStyles } from '@material-ui/core/styles';
import { ToastsProviderInterface } from './Interface';
import { useMobile } from '../../services/hooks/useMobile';
import { getConfigStore } from '../../store/config/actions';

const useStyles = makeStyles({
    root: {
        width: 0,
    },
});

export const ToastsProvider: FC<ToastsProviderInterface> = ({ children }: ToastsProviderInterface): JSX.Element => {
    const isMobile = useMobile();
    const config = useSelector(getConfigStore);
    const classes = useStyles();

    return (
        <SnackbarProvider
            classes={classes}
            preventDuplicate
            autoHideDuration={null}
            content={(key, value: any) => (
                <NotistackSnackbar
                    key={value.key}
                    message={value.message}
                    severity={value.severity}
                    isDesktop={!isMobile}
                    menuOpened={!config.drawerMenuFolded}
                    width={value.width}
                    open
                />
            )}
        >
            {children}
        </SnackbarProvider>
    );
};
